import { render } from "./InstructionCarousel.vue?vue&type=template&id=39bd31b2"
import script from "./InstructionCarousel.vue?vue&type=script&lang=ts"
export * from "./InstructionCarousel.vue?vue&type=script&lang=ts"

import "./InstructionCarousel.vue?vue&type=style&index=0&id=39bd31b2&lang=scss"
script.render = render

export default script